<ion-icon [name]="Icon" [color]="Color">
</ion-icon>
<span [title]="Title"></span>
